import ga from '../utils/ga'

export const reportSearch = (eventLabel: string) => {
  ga('send', {
    hitType: 'event',
    eventCategory: 'Block interaction; Search',
    eventAction: 'click;button',
    eventLabel
  })
}

export const reportFocusSearch = (eventLabel: string) => {
  ga('send', {
    hitType: 'event',
    eventCategory: 'Block interaction; Search',
    eventAction: 'focus on;search',
    eventLabel
  })
}
